/**
 * expects a path to in the home depot assets
 * @param {*} src  string /v1/path-to-pro/image.svg
 * @returns string
 */
export function generateImageSource(src) {
  return `https://assets.homedepot-static.com${src}`;
}